import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public blockingCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public nonBlockingCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private blockingCount = 0;
  private nonBlockingCount = 0;

  public showSpinner(blocking: boolean) {
    if (blocking) {
      this.blockingCount++;
      this.blockingCount$.next(this.blockingCount);
    } else {
      this.nonBlockingCount++;
      this.nonBlockingCount$.next(this.nonBlockingCount);
    }
  }

  public hideSpinner(blocking: boolean) {
    if (blocking) {
      this.blockingCount--;
      this.blockingCount$.next(this.blockingCount);
    } else {
      this.nonBlockingCount--;
      this.nonBlockingCount$.next(this.nonBlockingCount);
    }
  }
}
